<template>
    <div>
        <b-overlay :show="show" rounded="sm" class="pt-20">
            <div v-if="acceso">
                <b-card sub-title="" class="position-static">
                    <div>
                        <b-row>
                            <b-col md="12" sm="12">
                                <b-button
                                    variant="secondary"
                                    class="mb-1 btn-sm-block"
                                    @click="$router.go(-1)"
                                    pill
                                >
                                    <feather-icon
                                        icon="ArrowLeftIcon"
                                        class="mr-50"
                                    />
                                    Volver
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-if="opPlayer == 1">
                        <player-bitmovin
                            :canal="canal"
                            :info-player="infoPlayer"
                        />
                    </div>
                    <div v-else-if="opPlayer == 2">
                        <player-js :canal="canal" :info-player="infoPlayer" />
                    </div>
                </b-card>
            </div>
            <div v-else>
                <b-alert variant="warning" :show="true" class="mt-500">
                    <div class="alert-body" v-if="msn != ''">
                        <feather-icon icon="InfoIcon" class="mr-50" />
                        Estimado(a) {{ userData.fullName }}, {{ msn }}
                        <strong v-if="msn_pago != ''">
                            {{ msn_pago }}
                            <b-button
                                class="btn"
                                variant="warning"
                                :to="{
                                    name: 'canal-pago',
                                    params: { id: idcanal }
                                }"
                            >
                                <feather-icon
                                    icon="ShoppingCartIcon"
                                    class="mr-50"
                                />
                                <span>COMPRAR</span>
                            </b-button>
                        </strong>
                    </div>
                </b-alert>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BButton,
    BAlert,
    BSpinner,
    BOverlay,
    BIconWatch,
    BCard
} from "bootstrap-vue";
import router from "@/router";
import PlayerBitmovin from "./PlayerBitmovin";
import PlayerJs from "./PlayerJs";

export default {
    components: {
        BRow,
        BCol,
        BButton,
        BAlert,
        BSpinner,
        BOverlay,
        BIconWatch,
        BCard,
        PlayerBitmovin,
        PlayerJs,
    },
    setup() {},
    data() {
        return {
            show: false,
            userData: JSON.parse(localStorage.getItem("userData")),
            acceso: false,
            idcanal: router.currentRoute.params.id,
            canal: {},
            infoPlayer: {},
            msn: "",
            msn_pago: "",
            opPlayer: null
        };
    },
    created() {
        this.show = true;
        this.$http
            .get("/api/canal-play", {
                params: {
                    idcanal: this.idcanal,
                    idusuario: this.userData.id
                }
            })
            .then(response => {
                this.show = false;
                this.acceso = response.data.acceso;
                this.msn = response.data.msn;
                this.canal = response.data.data;
                this.infoPlayer = response.data.info;
                this.opPlayer = response.data.op_player;

                this.addTrack();
            })
            .catch(error => {
                this.show = false;
                this.$swal({
                    title: error.response.data.error ?? "Error",
                    icon: "error",
                    customClass: {
                        title: "text-secondary",
                        confirmButton: "btn btn-secondary"
                    },
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        this.$router.go(-1);
                    }
                });
            });
    },
    methods: {
        async addTrack() {
            this.$gtag.event("view_item", {
                event_category: "player",
                event_label: "player view",
                value: this.idcanal
            });
        }
    }
};
</script>
